// video event tracking for ga/gtm
function sendVideoEvent(action, element) {

    var videoTitle = jQuery(element).data('title');

    ga('send', {
        hitType: 'event',
        eventCategory: 'Video',
        eventAction: action,
        eventLabel: videoTitle + ': ' + element.currentSrc,
        nonInteraction: false
    });

}

jQuery(document).on('gform_post_render', function (event, formId) {
    const $form = jQuery(`#gform_${formId}`);
    const isAjax = ($form.attr('target') || '').includes('gform_ajax');
    if (isAjax) return;
  
    $form.find('.gform_ajax_spinner').remove();
  
    const spinner = `
      <img id="gform_ajax_spinner_${formId}" class="gform_ajax_spinner"
           src="https://${window.location.hostname}/wp-content/plugins/gravityforms/images/spinner.svg"
           alt="Loading..." width="20" height="20" style="margin-left:10px; display:none;">
    `;
  
    $form.find('.gform_button').each(function () {
      jQuery(this).after(spinner);
    });
  });